import React from 'react';
import { Button } from '../../button';

const SubmitButton = (props) => <Button type="submit" {...props} />;

export default SubmitButton;
